// src/components/ActiveProjectBadge.jsx
import { useState } from 'react';
import { FiFolder, FiPrinter, FiDatabase } from 'react-icons/fi';
import { useProjects } from '../context/ProjectContext';
import ProjectPickerModal from './ProjectPickerModal';
import PrintModal from './PrintModal';
import styles from '../styles/CalculatorTabs.module.css';
import DataModal from './DataModal';

export default function ActiveProjectBadge() {
    const { activeProjectName } = useProjects();
    const [showProj, setShowProj] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [showData, setShowData] = useState(false);

    return (
        <>
            <nav className={`${styles.tabnav} ${styles.metaNav}`}>

                <button
                    type="button"
                    className={styles.tabButton}
                    onClick={() => setShowData(true)}
                    title="Eksportér/importér data (lokal backup)"
                >
                    <FiDatabase aria-hidden />
                    <span>Data</span>
                </button>

                <button
                    type="button"
                    className={styles.tabButton}
                    onClick={() => setShowPrint(true)}
                    title="Udskriv"
                >
                    <FiPrinter aria-hidden />
                    <span>Udskriv</span>
                </button>

                <div className={styles.projectBtn}>
                    <button
                        type="button"
                        className={styles.tabButton}
                        onClick={() => setShowProj(true)}
                        title="Skift eller opret projekt"
                    >
                        <FiFolder aria-hidden />
                        <span>Projekt</span>
                    </button>

                    <small
                        className={styles.projName}
                        title={activeProjectName || 'Intet projekt valgt'}
                        style={{ visibility: activeProjectName ? 'visible' : 'hidden' }}
                    >
                        {activeProjectName}
                    </small>
                </div>
            </nav>

            <ProjectPickerModal open={showProj} onClose={() => setShowProj(false)} />
            <PrintModal open={showPrint} onClose={() => setShowPrint(false)} />
            <DataModal open={showData} onClose={() => setShowData(false)} />

        </>
    );
}
